import { Injectable } from '@angular/core';
import { Bericht } from '../models/Bericht';
import { Observable, of } from 'rxjs';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import * as firebase from 'firebase';
import { map } from 'rxjs/operators';
import Timestamp = firebase.firestore.Timestamp;

@Injectable({
              providedIn: 'root'
            })
export class BerichtenService {
  private berichtenCollection: AngularFirestoreCollection<BerichtenDTO>;

  constructor(private firestore: AngularFirestore) {
  }

  get(): Observable<Bericht[]> {
    this.berichtenCollection = this.firestore.collection('berichten', (reference) => {
      return reference.orderBy('date', 'desc');
    });

    return this.berichtenCollection.valueChanges().pipe(
      map((dtos: BerichtenDTO[]) => this.toMessageArray(dtos))
    );
  }

  private toMessageArray(dtos: BerichtenDTO[]) {
    const result: Bericht[] = [];
    dtos.forEach((dto: BerichtenDTO) => {
      const date = dto.date.toDate().toDateString();
      result.push(new Bericht(dto.author, dto.text, dto.imageId, date));
    });
    return result;
  }

  addBericht(bericht: Bericht): Observable<string> {
    const now = Timestamp.fromDate(new Date());
    const dto: BerichtenDTO = new BerichtenDTO(bericht.author, bericht.text, bericht.image, now);
    this.berichtenCollection.add({ ...dto });
    return of('ok');
  }

}

class BerichtenDTO {
  constructor(readonly author: string,
              readonly text: string,
              readonly imageId: string,
              readonly date: Timestamp) {
  }
}
